import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { setDateLocale } from "./utils/dateConfig";

import es from "./locales/es/translation.json";
import en from "./locales/en/translation.json";
import ca from "./locales/ca/translation.json";

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			es: { translation: es },
			en: { translation: en },
			ca: { translation: ca },
		},
		fallbackLng: "es",
		supportedLngs: ["es", "en", "ca"],
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ["localStorage", "navigator"],
			lookupLocalStorage: "i18nextLng",
			cacheUserLanguage: true,
		},
	});

i18n.on("languageChanged", (lang) => {
	setDateLocale(lang);
});

// Aplica el locale del usuario (viene del backend) y lo persiste en localStorage
export function applyUserLocale(user) {
	const locale = user?.locale;
	if (locale && i18n.options.supportedLngs.includes(locale)) {
		i18n.changeLanguage(locale);
	}
}

if (process.env.NODE_ENV === "development") {
	window.i18n = i18n;
}

export default i18n;
